import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { neutralDark40 } from "../../../constants/colors";
import { Button } from "../../button";
export var StyledActionButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 32px;\n    color: ", ";\n"])), neutralDark40);
//# sourceMappingURL=ActionButton.js.map